const regDay = 'Reg day';
const lifeTime = 'Lifetime';

export const getPeriodValue = ({ length = 0, unit = '' } = {}) => {
  const unitKey = unit.toLowerCase();
  if (!length) {
    return lifeTime;
  } else if (unitKey !== 'days' || length > 1) {
    return `${length} ${unitKey}`;
  } else {
    return regDay;
  }
};
